/**
 * The prefix of the {@code localStorage} key into which {@link storeConfig}
 * stores and from which {@link restoreConfig} restores.
 *
 * @protected
 * @type string
 */
export const _CONFIG_STORE_PREFIX = 'config.js';

/**
 * The list of all possible UI buttons.
 *
 * @protected
 * @type Array<string>
 */
export const TOOLBAR_BUTTONS = [
    'microphone', 'camera', 'closedcaptions', 'desktop', 'fullscreen', 'participants-pane',
    'fodeviceselection', 'hangup', 'profile', 'chat', 'sharedvideo', 'settings',
    'raisehand', 'videoquality', 'invite', 'feedback', 'stats', 'shortcuts',
    'tileview', 'filmstrip', 'horizontalstrip', 'stageview', 'select-background', 'download', 'help',
    'zoomin', 'zoomout', 'voicecommand', 'fit-video', 'pin-user', 'moderator-pin',
    'polls', 'participant-count', 'fixed-floating', 'conference-view', 'reactions', 'volume-control',
    'shareaudio', 'embedmeeting', 'recording', 'livestreaming', 'etherpad', 'genericiframe',
    'mute-everyone', 'mute-video-everyone', 'security', 'noise-suppression', 'localrecording'
];

/**
 * The set of feature flags.
 *
 * @enum {string}
 */

export const FEATURE_FLAGS = {
    SSRC_REWRITING: 'ssrcRewritingEnabled'
};


/**
 * Api Url for joining prejoin.
 */

/** DO NOT CHANGE BELOW PARAMETERS EVER (In both MeetHour & Branded App case)  */

export const saveGuestDetails = 'meeting/save_meeting_guest_details';

export const apiKEY = 'b709af18554cee13bd74d8ab20aad74a4c6d46bd520ede88b54144b40e4ff3a8';

export const mtDomain = 'meethour.io';

export const androidPackageId = 'go.meethour.io';

export const iosPackageId = 'go.meethour.io';


